const MONTHLY_DISPLAY = {
  perPeriodLabel: 'Per Month',
  firstPeriodLabel: '1st Month',
  secondPeriodLabel: '2nd Month',
  ongoingLabel: 'Ongoing',
  tiers: [
    { key: 'monthly', label: 'Monthly' },
    { key: '6months', label: '6 Months' },
    { key: '12months', label: '12 Months' },
  ],
};

const FOUR_WEEK_DISPLAY = {
  perPeriodLabel: 'Per 4 Weeks',
  firstPeriodLabel: '1st Period',
  secondPeriodLabel: '2nd Period',
  ongoingLabel: 'Ongoing',
  tiers: [
    { key: 'monthly', label: '4 Weeks' },
    { key: '6months', label: '6 Periods (24 Weeks)' },
    { key: '12months', label: '1 Year (13 Periods)' },
  ],
};

export const getPricingDisplay = (billingPeriod, excludeTiers = []) => {
  const base = billingPeriod === '4week' ? FOUR_WEEK_DISPLAY : MONTHLY_DISPLAY;
  if (!excludeTiers.length) {
    return base;
  }
  return {
    ...base,
    tiers: base.tiers.filter((tier) => !excludeTiers.includes(tier.key)),
  };
};

export const getPeriodRate = (tierData) =>
  tierData?.perPeriod ?? tierData?.perMonth ?? 0;

export const formatInstallFee = (amount) => {
  if (amount === 0) {
    return 'FREE';
  }
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
};
